/**
 * 注册登录相关接口
 */

const login = {
  // 注册登录落地页
  sendH5sendRgstCode: ['/lt-web/xs/h5/sendRgstCode'], // 发送注册短信验证码
  getH5CaptchaImage: ['/lt-web/xs/h5/captchaImage'], // 获取图片验证码
  sendH5CaptchaSms: ['/lt-web/xs/h5/sendSms'], // 图片验证码校验通过后发送短信验证码
  submitH5GeneralRegister: ['/lt-web/xs/h5/general/register'], // h5通用登录
  // 渠道引导登录页
  sendGuideSmsCode: ['/lt-web/xs/h5/sendRgstCode'], // 发送引导短信验证码
  registerGuideLogin: ['/lt-web/xs/h5/register'] // 渠道注册登录
}

export default login
